export default "__VITE_ASSET__49eeb9bb__"